import httpClient from "./httpClient";

export const getHomepageService = async () => {
  return await httpClient.get("/api/homepage");
};

export const getImageUrl = async (img: string) => {
  return await httpClient.get("/image/{react?}");
};
